import ChoroplethSettings from './Choropleth';
export default ChoroplethSettings;